import React from 'react';

const Terms: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold mb-8 text-center">Условия использования</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">1. Общие положения</h2>
          <p className="text-gray-700">
            Настоящие условия использования регулируют отношения между ООО "Ай-ти Джой" (далее — «Компания») и пользователями сайта itjoy.space (далее — «Сайт»).
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">2. Интеллектуальная собственность</h2>
          <p className="text-gray-700">
            Все материалы, размещенные на Сайте, включая тексты, изображения, логотипы, дизайн и программное обеспечение, являются собственностью Компании и защищены законодательством об интеллектуальной собственности.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">3. Использование услуг</h2>
          <p className="text-gray-700">
            Используя услуги Компании, вы соглашаетесь с условиями предоставления услуг, которые могут быть дополнительно оговорены в договоре на оказание услуг.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">4. Конфиденциальность</h2>
          <p className="text-gray-700">
            Компания обязуется соблюдать конфиденциальность информации, полученной от клиентов, в соответствии с действующим законодательством и политикой конфиденциальности.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">5. Ответственность</h2>
          <p className="text-gray-700">
            Компания не несет ответственности за убытки, возникшие в результате использования или невозможности использования Сайта и услуг Компании.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">6. Изменение условий</h2>
          <p className="text-gray-700">
            Компания оставляет за собой право вносить изменения в настоящие условия использования. Изменения вступают в силу с момента их публикации на Сайте.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">7. Контактная информация</h2>
          <p className="text-gray-700">
            По всем вопросам, связанным с условиями использования, обращайтесь по электронной почте: mail@itjoy.space
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms; 